<div class="c-card c-card--height-fit" [ngClass]="{'c-card--selected': vm.isSelected()}" style="border: #FFFFFF 1px solid;cursor:pointer;" *ngIf="vm.isInitialized" id="{{vm.coachingTopic.id}}-scrollTo" (click)="vm.onSelected()">
    <div class="c-content c-content--lg">
        <div class="o-grid o-grid--wrap o-grid--center-h">
            <div class="o-grid__cell o-grid__cell--w-80 o-grid__cell--center-h o-grid__cell--slim" [ngClass]="{'o-grid__cell--w-35@lg-and-up': !vm.isNarrow}">
                <img src="{{vm.imageUrl}}" alt="{{vm.title}}">
            </div>
            <div style="min-height:80px;" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-60@sm-and-up o-grid__cell--w-100@md-and-up o-grid__cell--slim u-ost-md" [ngClass]="{'o-grid__cell--w-65@lg-and-up': !vm.isNarrow}">
                <p class="c-text c-text--bold o-grid__cell--center-h c-text--lg u-osb-md" [innerHtml]="vm.title"></p>
                <p class="c-text c-text--lines u-osb-md">{{ vm.text }}</p>
            </div>
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p" *ngIf="!vm.coachingTopic.parent">
				<a id="selectCoachingTopicButton{{vm.coachingTopic.id}}" class="c-button c-button--md c-button--s2 c-button--fit">{{'Common.Next' | translate }}</a>
			</div>
		</div>
    </div>
</div>
